export const CREATE_Language = 'CREATE_Language ';

export const createLanguage = language => ({
    type: CREATE_Language,
    payload: {language}
});

export const REMOVE_Language = 'REMOVE_Language ';

export const removeLanguage = language => ({
    type: REMOVE_Language,
    payload: {language}
});
